import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { Input } from '../ui/input';

export const CustomFields = ({ entity, value, onChange }) => {
  const { data: defs } = useQuery({ queryKey: ['acad-fields', entity], queryFn: () => api.get('/acad/custom-fields', { params: { entity } }).then((r) => r.data).catch(() => []) });
  const active = (defs || []).filter((d) => d.active);
  if (!active.length) return null;
  const set = (k, v) => onChange({ ...(value || {}), [k]: v });
  return (
    <div className="grid sm:grid-cols-3 gap-2 mt-2" data-testid={`custom-fields-${entity}`}>
      {active.map((d) => (
        <label key={d.key} className="text-xs text-slate-500">{d.label}{d.required ? ' *' : ''}
          {d.field_type === 'select' || d.field_type === 'yesno' ? (
            <select data-testid={`cf-${d.key}`} className="w-full border border-slate-200 rounded-md px-2 py-2 text-sm bg-white" value={value?.[d.key] || ''} onChange={(e) => set(d.key, e.target.value)}>
              <option value="">Choose...</option>
              {(d.field_type === 'yesno' ? ['Yes', 'No'] : d.options).map((o) => <option key={o}>{o}</option>)}
            </select>
          ) : (
            <Input data-testid={`cf-${d.key}`} type={d.field_type === 'number' ? 'number' : d.field_type === 'date' ? 'date' : 'text'} value={value?.[d.key] || ''} onChange={(e) => set(d.key, e.target.value)} />
          )}
        </label>
      ))}
    </div>
  );
};
